var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.961,
    height: 10.405,
    viewBox: "0 0 9.961 10.405",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-cog",
    "data-name": "Icon awesome-cog",
    d: "M11.144,7.022l-.894-.516a4.041,4.041,0,0,0,0-1.473l.894-.516a.254.254,0,0,0,.115-.294,5.225,5.225,0,0,0-1.147-1.985.252.252,0,0,0-.31-.048l-.894.516a3.959,3.959,0,0,0-1.275-.736V.941A.251.251,0,0,0,7.436.7,5.274,5.274,0,0,0,5.145.7a.251.251,0,0,0-.2.245V1.973a4.084,4.084,0,0,0-1.275.736l-.892-.516a.249.249,0,0,0-.31.048A5.193,5.193,0,0,0,1.323,4.226a.251.251,0,0,0,.115.294l.894.516a4.041,4.041,0,0,0,0,1.473l-.894.516a.254.254,0,0,0-.115.294A5.225,5.225,0,0,0,2.47,9.3a.252.252,0,0,0,.31.048l.894-.516a3.959,3.959,0,0,0,1.275.736V10.6a.251.251,0,0,0,.2.245,5.274,5.274,0,0,0,2.291,0,.251.251,0,0,0,.2-.245V9.571A4.084,4.084,0,0,0,8.91,8.835l.894.516a.249.249,0,0,0,.31-.048,5.193,5.193,0,0,0,1.147-1.985.259.259,0,0,0-.117-.3ZM6.29,7.448A1.678,1.678,0,1,1,7.968,5.77,1.68,1.68,0,0,1,6.29,7.448Z",
    transform: "translate(-1.311 -0.569)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewall);
export default __webpack_public_path__ + "static/media/viewall.e9a80fcf265c30376387d988650bd18d.svg";
export { ForwardRef as ReactComponent };